import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {usePermissions} from "../../../hooks/usePermissions";
import {useAccessDeniedMessage} from "../../../hooks/useAccessDeniedMessage";
import {UPDATE_CUSTOMER} from "../../../constants/eInvoicePermissions";
import PermissionDeniedWrapper from "../../../components/PermissionDeniedWrapper";

const CustomerActionsMenu = ({ customer }) => {
  const [anchorEl, setAnchorEl] = useState(null);
    const {hasEInvoicePermission} = usePermissions();
    const accessDeniedMessage = useAccessDeniedMessage();
    const canEdit = hasEInvoicePermission(UPDATE_CUSTOMER);
  const navigate = useNavigate();

  const onClickingDetails = () => {
    navigate('/customers/:id'.replace(':id', customer.profile_id));
  };
  const onClickingEdit = () => {
    navigate('/customers/:id/edit'.replace(':id', customer.profile_id));
  };

  const user = useSelector((state) => state.user.user);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton data-testid="action-icon-button" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              boxShadow: '4px 4px 10px 0px rgba(0,0,0,0.2)',
            },
          },
        }}
      >
        <MenuItem data-testid="details" key="details" onClick={onClickingDetails}>
          {'Details'}
        </MenuItem>
          <PermissionDeniedWrapper show={!canEdit} title={accessDeniedMessage}>
              <MenuItem data-testid="edit" disabled={!canEdit} key="edit" onClick={onClickingEdit}>
                  {'Edit'}
              </MenuItem>
          </PermissionDeniedWrapper>

      </Menu>
    </>
  );
};

export default CustomerActionsMenu;
